import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Container, Divider, Form, Grid, GridRow, GridColumn, Segment } from "semantic-ui-react";
import { createSite, updateSite, getAuthUser, getCompany, getSite } from "../superActions";
import { Formik } from "formik";
import MySelectInput from "../../../app/common/form/MySelectInput";
import MyTextInput from "../../../app/common/form/MyTextInput";

export default function SitesDetailedPage(props) {
    let parts = window.location.href.split("/");
    let siteId = parts.pop() || parts.pop();
    const [profile, setProfile] = useState([]);
    const [companyList, setCompanyList] = useState([]);
    const [site, setSite] = useState({ companyId: "", siteName: "" });

    useEffect(() => {
        getAuthUser().then(
            (res) => {
                if (res.exists) {
                    setProfile(res.data());
                }
            },
            (err) => {
                console.log(err);
            }
        );
        getSite(siteId).then(
            (res) => {
                if (res.exists) {
                    setSite(res.data());
                }
            },
            (err) => {
                console.log(err);
            }
        );
        getCompany().then(
            (res) => {
                let list = [];
                res.forEach((doc) => {
                    if (doc.exists) {
                        let appObj = { ...doc.data(), id: doc.id };
                        list.push(appObj);
                    }
                });

                let companyList = [];
                companyList = list.map(function (company) {
                    return {
                        key: company.id,
                        text: company.companyName,
                        value: company.id,
                    };
                });

                companyList.sort((a, b) => (b.text < a.text ? 1 : -1));

                setCompanyList(companyList);
            },
            (err) => {
                console.log(err);
            }
        );
    }, []);
    return (
        <Container>
            <Segment>
                <Formik
                    initialValues={site}
                    enableReinitialize="true"
                    validate={(values) => {
                        const error = {};
                        return error;
                    }}
                    onSubmit={async (values, { setSubmitting }) => {
                        if (siteId !== "0") {
                            values.id = siteId;
                            await updateSite(values);
                        } else {
                            await createSite(values);
                        }

                        props.history.push("/super/sites/");
                    }}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue, dirty }) => (
                        <form onSubmit={handleSubmit} className="ui form">
                            <Grid>
                                <GridRow>
                                    <GridColumn width={8}>
                                        <Form.Field>
                                            <MySelectInput
                                                width={8}
                                                label="Company"
                                                name="companyId"
                                                options={companyList}
                                                value={values.companyId}
                                                onChange={(field, value) => setFieldValue("companyId", value.value)}
                                                placeholder="Select your Company"
                                                disabled={profile.isSuper === true ? false : true}
                                            />
                                        </Form.Field>
                                    </GridColumn>

                                    <GridColumn width={8}>
                                        <Form.Field>
                                            <MyTextInput label="Site Name" name="siteName" type="text" placeholder="Site Name" />
                                        </Form.Field>
                                    </GridColumn>
                                </GridRow>
                            </Grid>

                            <Divider />

                            <Button
                                disabled={!dirty || isSubmitting}
                                loading={isSubmitting}
                                size="large"
                                type="submit"
                                positive
                                content={siteId !== "0" ? "Update Site" : "Create Site"}
                            />
                            <Button size="large" as={Link} to={`/super/sites/`}>
                                Cancel
                            </Button>
                        </form>
                    )}
                </Formik>
            </Segment>
        </Container>
    );
}
